import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
    <p>
      <strong><span style="font-family: Arial, Helvetica, sans-serif; font-size: 14px;">Description</span></strong>
    </p>
    <p>
        <span style="font-family: Arial, Helvetica, sans-serif; font-size: 14px; line-height: 107%;">
            This action was generated because either (A) 3 or more PNOVC packages were returned by the driver that marked them missing, OR (B) an OV package was Verify Scanned during loadout, marked missing on road, and return to station at end
            of the day all by the same driver.
        </span>
    </p>
    <p>
      <strong><span style="font-family: Arial, Helvetica, sans-serif; font-size: 14px;">Impact</span></strong>
    </p>
    <p>
        <span style="font-family: Arial, Helvetica, sans-serif; font-size: 14px; line-height: 107%;">
            PNOV-Compliant packages create extra stops for drivers, decrease route efficiency, and have an overall cost impact $12.54 per package. Overall, this causes customer dissatisfaction due to potential delays in delivery.
        </span>
    </p>
    <p>
      <strong><span style="font-family: Arial, Helvetica, sans-serif; font-size: 14px;">Resolution Steps</span></strong>
    </p>
    <p><span style="font-family: Arial, Helvetica, sans-serif; font-size: 14px;">Please fill out the following questionnaire to help the station identify potential process improve opportunities and remove driver barriers.</span>
    </p>
    <ul>
      <li>
        <div>
          <p><span style="color: black; font-family: Arial, Helvetica, sans-serif; font-size: 14px; line-height: normal;">Who was talked to regarding this action? DA/DSP Owner/ Dispatch</span>
          </p>
        </div>
      </li>
      <li>
        <div>
          <p><span style="color: black; font-family: Arial, Helvetica, sans-serif; font-size: 14px; line-height: normal;">When did the conversation occur? During RTS/On-Road Gemba</span>
          </p>
        </div>
      </li>
      <li>
        <div>
          <p><span style="color: black; font-family: Arial, Helvetica, sans-serif; font-size: 14px; line-height: normal;">Did the driver consolidate bags? Yes/No</span>
          </p>
        </div>
      </li>
      <li>
        <div>
          <p>
                    <span
                      style="color: black; font-family: Arial, Helvetica, sans-serif; font-size: 14px; line-height: normal;">
                        Where did the driver find the “Missing” package? A different bag/Mixed with OV/Random Place in the Van/Do not Recall
                    </span>
          </p>
        </div>
      </li>
      <li>
        <div>
          <p>
                    <span
                      style="color: black; font-family: Arial, Helvetica, sans-serif; font-size: 14px; line-height: normal;">
                        What prevented the driver from re-attempting the 'Missing' Package? I did not know packages should be reattempted/ I did not know how to reattempt a package/I ran out of time
                    </span>
          </p>
        </div>
      </li>
    </ul>
    <p>
      <strong><span style="font-family: Arial, Helvetica, sans-serif; font-size: 14px;">Supplemental Links</span></strong>
    </p>
    <p>
        <span style="font-family: Arial, Helvetica, sans-serif; font-size: 14px;">
            1) <span className="wikiinternallink"><a
          href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/c138825e-cdb4-4915-b93c-a76ac43f28db?# ">PNOV Quicksight</a></span><br/>
            2)
            <span className="wikiinternallink">
                <a
                  href="https://amazonprojects.corp.amazon.com/sites/AMZLACES2/processdocs/SOPs/Reattempting%20Packages%20Missing.pdf ">
                    <span className="wikiinternallink"
                          style="font-family: Arial, Helvetica, sans-serif; font-size: 14px; color: rgb(52, 152, 219); font-family: Arial, Helvetica, sans-serif; font-size: 14px; line-height: 107%;">
                        Re-Attempt SOP
                    </span>
                </a>
            </span>
        </span>
    </p>
  </div>`
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_PNOVRTS.jsx